<template>
  <div class="widget-palette">
    <div class="widget-palette__section">
      <h6 class="widget-palette__heading">Widgets</h6>
      <p class="widget-palette__hint">Drag onto canvas</p>
      <div class="widget-palette__list">
        <button
          v-for="item in catalog"
          :key="item.type"
          type="button"
          class="btn btn-sm btn-outline-primary widget-palette__btn"
          draggable="true"
          @dragstart="onDragStart($event, item)"
          @dragend="onDragEnd"
          @click="$emit('add', item.type)"
        >
          <i class="fas fa-grip-vertical widget-palette__grip" aria-hidden="true"></i>
          <span>{{ item.title }}</span>
        </button>
      </div>
    </div>
    <div class="widget-palette__section">
      <h6 class="widget-palette__heading">Presets</h6>
      <div class="widget-palette__list">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary widget-palette__btn"
          @click="$emit('preset', 'director-full')"
        >
          Director Full
        </button>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary widget-palette__btn"
          @click="$emit('preset', 'show-caller')"
        >
          Show Caller
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const WIDGET_DND_MIME = 'application/x-controllabs-widget'

export default {
  computed: {
    ...mapGetters('workspace', ['catalog']),
  },
  methods: {
    onDragStart(e, item) {
      if (!e.dataTransfer) return
      e.dataTransfer.effectAllowed = 'copy'
      e.dataTransfer.setData(WIDGET_DND_MIME, item.type)
      e.dataTransfer.setData('text/plain', item.type)
      document.body.classList.add('ws-widget-dragging')
    },
    onDragEnd() {
      document.body.classList.remove('ws-widget-dragging')
    },
  },
  beforeDestroy() {
    document.body.classList.remove('ws-widget-dragging')
  },
}
</script>

<style scoped>
.widget-palette {
  padding: 0.35rem;
}
.widget-palette__heading {
  margin: 0 0 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--ws-text-muted, #6c757d);
}
.widget-palette__hint {
  margin: -0.15rem 0 0.45rem;
  font-size: 0.7rem;
  color: var(--ws-text-muted, #6c757d);
  opacity: 0.85;
}
.widget-palette__section + .widget-palette__section {
  margin-top: 0.75rem;
  padding-top: 0.65rem;
  border-top: 1px solid var(--ws-widget-border, #e9ecef);
}
.widget-palette__list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.widget-palette__btn {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.4rem;
  text-align: left;
  min-height: 34px;
  cursor: grab;
  user-select: none;
}
.widget-palette__btn:active {
  cursor: grabbing;
}
.widget-palette__grip {
  opacity: 0.55;
  font-size: 0.75rem;
}

/* Tablet: horizontal chip strip so canvas keeps vertical space */
@media (max-width: 1199.98px) {
  .widget-palette {
    padding: 0.25rem 0;
  }
  .widget-palette__section {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
  }
  .widget-palette__section + .widget-palette__section {
    margin-top: 0.45rem;
    padding-top: 0.45rem;
  }
  .widget-palette__heading {
    margin: 0;
    flex-shrink: 0;
    width: 4.25rem;
  }
  .widget-palette__hint {
    display: none;
  }
  .widget-palette__list {
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    gap: 0.35rem;
    padding-bottom: 0.15rem;
    min-width: 0;
  }
  .widget-palette__btn {
    flex-shrink: 0;
    white-space: nowrap;
    min-height: 40px;
    padding-left: 0.7rem;
    padding-right: 0.7rem;
  }
}
</style>
